export default "__VITE_ASSET__a9fbf740__"